import axios from 'axios'
import i18next from 'i18next'

/**
 * Creates an API with the correct headers and error parsing/handling for communication with our servers.
 * Displays a blocking login error message if a login error is received.
 */
export default class BaseApi {
  constructor() {
    this.axios = axios.create({
      withCredentials: true,
      headers: {
        Accept: 'application/json, text/plain/, */*',
        'X-Requested-With': 'XMLHttpRequest',
      },
      transformResponse: [
        responseText => {
          const responseData = JSON.parse(responseText)

          if (responseData.error) {
            // Display our blocking login error message if the user isn't logged in
            if (responseData.error === 'notLoggedIn') {
              // eslint-disable-next-line
              edulab.pages.Page.displayBlockingLoginErrorMessage()
              throw new Error('')
            }

            // Throw a new error with the returned error message
            throw new Error(responseData.error_msg || responseData.error)
          }

          // Unwrap the response data
          return responseData.data !== undefined
            ? responseData.data
            : responseData
        },
      ],
    })
    this.axios.interceptors.response.use(
      // Pass through any ordinary response
      response => response,
      // Translate 'Network Error' into something humans understand and let anything else pass as is.
      error => {
        throw error.message === 'Network Error'
          ? new Error(i18next.t('network-errors.network-error'))
          : error
      }
    )
  }
}

/**
 * A global instance of the API
 * @type {BaseApi}
 */
export const apiInstance = new BaseApi()

/**
 * The Axios instance living inside the global API instance.
 * @type {AxiosInstance}
 */
export const axiosInstance = apiInstance.axios
